export const malomoTracking = async (url: URL) => {
  const bearerToken = "Bearer " + process.env.MALOMO_API_KEY;
  const headers = {
    Authorization: bearerToken,
    Accept: "application/vnd.malomo+json; version=2",
  };
  try {
    const response = await fetch(url, { headers });
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error);
  }
};
